
        var result = require("!!../../../../node_modules/css-loader/index.js!./sent.to.bid.management.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Client/app/views/tenders/sent.to.bid.management.component.css
// module id = 1243
// module chunks = 0